export default __webpack_public_path__ + "static/media/SMARTREACH.32754c11.mp4";